(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fathers-day-buy-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-fd-hero]').forEach(function (root) {
    var image = root.querySelector('[data-fd-image]');
    var link = root.querySelector('[data-fd-link]');
    var title = root.querySelector('[data-fd-title]');
    var price = root.querySelector('[data-fd-price]');
    var cart = root.querySelector('[data-fd-cart]');
    var thumbs = root.querySelectorAll('[data-fd-thumb]');

    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-checked', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-checked', 'true');

        var data = thumb.dataset;
        var available = data.available === 'true';

        if (image) {
          image.src = data.image;
          if (data.imageAlt) image.alt = data.imageAlt;
        }
        if (link) link.href = data.url;
        if (title) title.textContent = data.title;
        if (price) price.innerHTML = data.price;
        if (cart) {
          cart.href = data.cartUrl;
          if (available) {
            cart.classList.remove('fd-hero__cta--soldout');
          } else {
            cart.classList.add('fd-hero__cta--soldout');
          }
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mothers-day-buy-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-md-hero]').forEach(function (root) {
    var image = root.querySelector('[data-md-image]');
    var link = root.querySelector('[data-md-link]');
    var title = root.querySelector('[data-md-title]');
    var price = root.querySelector('[data-md-price]');
    var cart = root.querySelector('[data-md-cart]');
    var thumbs = root.querySelectorAll('[data-md-thumb]');

    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-checked', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-checked', 'true');

        var data = thumb.dataset;
        var available = data.available === 'true';

        if (image) {
          image.src = data.image;
          if (data.imageAlt) image.alt = data.imageAlt;
        }
        if (link) link.href = data.url;
        if (title) title.textContent = data.title;
        if (price) price.innerHTML = data.price;
        if (cart) {
          cart.href = data.cartUrl;
          if (available) {
            cart.classList.remove('md-hero__cta--soldout');
          } else {
            cart.classList.add('md-hero__cta--soldout');
          }
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-flyout"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('[data-press-flyout]');
      if (!root || root.dataset.pfReady) return;
      root.dataset.pfReady = '1';

      var selector = root.getAttribute('data-trigger-selector') || 'marquee-component a[href]';
      var panel = root.querySelector('[data-pf-panel]');
      var iframe = root.querySelector('[data-pf-iframe]');
      var logoBox = root.querySelector('[data-pf-logo]');
      var external = root.querySelector('[data-pf-external]');
      var counter = root.querySelector('[data-pf-counter]');
      var cta = root.querySelector('[data-pf-cta]');
      var ctaLogo = root.querySelector('[data-pf-cta-logo]');
      var ctaLink = root.querySelector('[data-pf-cta-link]');
      var blockedDomains = (root.getAttribute('data-blocked-domains') || '')
        .split(/[\s,]+/)
        .map(function (s) { return s.trim().toLowerCase().replace(/^www\./, ''); })
        .filter(Boolean);
      var loadTimer = null;

      function hostnameOf(u) {
        try { return new URL(u).hostname.replace(/^www\./, ''); } catch (e) { return ''; }
      }
      function isBlocked(url) {
        if (!blockedDomains.length) return false;
        var host;
        try { host = new URL(url).hostname.toLowerCase(); } catch (e) { return false; }
        return blockedDomains.some(function (d) { return host === d || host.endsWith('.' + d); });
      }
      function clearLoadTimer() { if (loadTimer) { clearTimeout(loadTimer); loadTimer = null; } }
      function showCta(item) {
        clearLoadTimer();
        iframe.hidden = true;
        iframe.src = 'about:blank';
        ctaLogo.innerHTML = item.logoHTML;
        ctaLink.href = item.url;
        ctaLink.setAttribute('aria-label', 'Visit ' + item.label + ' directly in a new tab');
        cta.hidden = false;
      }
      function showFrame(item) {
        cta.hidden = true;
        iframe.hidden = false;
        iframe.src = item.url;
        clearLoadTimer();
        // Fallback for sites that silently hang (header X-Frame blocks are handled
        // up front via blockedDomains, since their failure isn't detectable here).
        loadTimer = setTimeout(function () { showCta(item); }, 7000);
      }

      // Build a de-duplicated, ordered list of press links. The marquee clones its
      // items for the infinite-scroll loop, so dedupe by resolved URL.
      var items = [];
      var seen = {};
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (a) {
        var url = a.href;
        if (!url || seen[url]) return;
        seen[url] = true;
        var img = a.querySelector('img');
        items.push({
          url: url,
          logoHTML: a.innerHTML,
          label: a.getAttribute('aria-label') || (img && img.alt) || hostnameOf(url)
        });
      });
      if (!items.length) return;

      var current = -1;
      var lastTrigger = null;

      function render(i) {
        current = (i % items.length + items.length) % items.length;
        var item = items[current];
        logoBox.innerHTML = item.logoHTML;
        external.href = item.url;
        external.setAttribute('aria-label', 'Open ' + item.label + ' article in a new tab');
        if (counter) counter.textContent = (current + 1) + ' / ' + items.length;
        if (isBlocked(item.url)) { showCta(item); } else { showFrame(item); }
      }

      function open(i, trigger) {
        lastTrigger = trigger || null;
        render(i);
        if (typeof root.showModal === 'function') {
          root.showModal();
        } else {
          root.setAttribute('open', '');
        }
        document.documentElement.classList.add('pf-lock');
        // Double rAF so the closed start-state (panel off-screen) is painted before
        // we flip to is-open — guarantees a smooth slide instead of a snap.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { root.classList.add('is-open'); });
        });
        var closeBtn = root.querySelector('[data-pf-close]');
        if (closeBtn) closeBtn.focus();
      }

      function finishClose() {
        if (typeof root.close === 'function') { root.close(); } else { root.removeAttribute('open'); }
        clearLoadTimer();
        iframe.src = 'about:blank';
        document.documentElement.classList.remove('pf-lock');
        panel.removeEventListener('transitionend', onEnd);
        if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      }
      function onEnd(e) { if (e.target === panel && e.propertyName === 'transform') finishClose(); }

      function close() {
        root.classList.remove('is-open');
        panel.addEventListener('transitionend', onEnd);
        setTimeout(function () { if (!root.classList.contains('is-open') && root.open) finishClose(); }, 450);
      }

      // Delegate clicks so marquee clones (added after load) are handled too.
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest(selector);
        if (!a) return;
        var idx = -1;
        for (var k = 0; k < items.length; k++) { if (items[k].url === a.href) { idx = k; break; } }
        if (idx === -1) return;
        e.preventDefault();
        open(idx, a);
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-pf-close]'), function (el) {
        el.addEventListener('click', close);
      });
      root.querySelector('[data-pf-prev]').addEventListener('click', function () { render(current - 1); });
      root.querySelector('[data-pf-next]').addEventListener('click', function () { render(current + 1); });
      iframe.addEventListener('load', clearLoadTimer);

      // Native dialog ESC -> animate out instead of instant close.
      root.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      // Click on the backdrop area (outside the panel) closes.
      root.addEventListener('click', function (e) { if (e.target === root) close(); });
      document.addEventListener('keydown', function (e) {
        if (!root.open) return;
        if (e.key === 'ArrowLeft') render(current - 1);
        else if (e.key === 'ArrowRight') render(current + 1);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
